import styled, { keyframes, css } from "styled-components";
import BREAKPOINTS from "../../Theme/Breakpoints";

const spin = keyframes`
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
`;

const teeter = keyframes`
  0%, 100% {
    transform: rotate(0deg);
  }
  50% {
    transform: rotate(16deg);
  }
`;

export const Wrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 6rem 0 0 0;

  ${BREAKPOINTS.MOBILE} {
    padding: 4rem 2rem 0;
  }
`;

export const Heading = styled.h3`
  margin: 0;
  font-size: 18px;
  font-family: "Poppins", sans-serif;
`;

export const Image = styled.img`
  display: block;
  width: 110px;
  ${(props) =>
    props.spin &&
    css`
      animation: ${spin} 10s linear infinite;
    `}
  ${(props) =>
    props.teeter &&
    css`
      animation: ${teeter} 1.5s ease-in-out infinite;
    `}

  ${BREAKPOINTS.TABLET} {
    width: 80px;
  }
`;

export const TopWrapper = styled.div`
  display: flex;
  justify-content: center;
  gap: 18px;

  ${BREAKPOINTS.MOBILE} {
    flex-direction: column;
  }
`;

export const Item = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 16px;
  padding: 1.5rem 3rem;
  gap: 12px;
  background-color: ${({ color }) => color};
  cursor: pointer;
  transition: transform 0.2s ease-in-out;

  &:hover {
    transform: scale(1.04);
  }

  ${BREAKPOINTS.TABLET} {
    gap: 4px;
    padding: 2rem;
    width: 40%;
  }

  ${BREAKPOINTS.MOBILE} {
    gap: 4px;
    padding: 2rem;
    line-height: 24px;
  }
`;
